import { ApiService } from '../../services'
import { Unauthorized } from '../../helpers/unauthorized.handler'
export const SettingsModule = {
    namespaced: true,
    state: {
        loading: false,  
    },
    actions: {
        async getSettings({ state, commit, dispatch }, config = {}) {
            if (config.cancelToken) {
                try {
                    const response = await ApiService.get('settings', {}, config);
                    const payload = response && response.data ? response.data : {};
                    return payload.data || payload;
                } catch (error) {
                    if (error && error.response) Unauthorized(dispatch, error);
                    throw error;
                }
            }
            const { loading } = state
            return await new Promise((resolve) => {
                if (loading === false) {
                    commit('LoadingTrue')
                    ApiService.get('settings', {}).then((response) => {
                        const payload = response && response.data ? response.data : {}
                        resolve(payload.data || payload)
                        commit('LoadingFalse')
                    }).catch(error => {
                        commit('LoadingFalse')
                        resolve({})
                        Unauthorized(dispatch, error)
                    })
                }else{
                    resolve({})
                }
            })
        },        
    },
    mutations: {
        LoadingFalse: (state) => {
            state.loading = false
        },
        LoadingTrue: (state) => {
            state.loading = true
        }
    },
    getters: {
        loading: state => state.loading,
    }
}


